import CheckmateApiClient from '../../../services/apiClient';
import { useQuery } from 'react-query';

const _apiClient = new CheckmateApiClient();

export const useGetQuadUsersByZone = (zoneGuid: string, dataScopeId?: number, enabled: boolean = true) => {
    return useQuery({
        queryKey: ['get-quad-zone-users', { zoneGuid, dataScopeId }],
        queryFn: async () => {
            const response = await _apiClient.getQuadZoneUsers(zoneGuid, dataScopeId);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error(`Failed to retrieve lookup data for zone`);
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        staleTime: Infinity,
        cacheTime: Infinity,
        enabled: enabled && !!zoneGuid
    });
};
